<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Login from "@/pages/Login.vue";
export default {
  name: "App",
  components: {
    Login,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue